<div *ngIf="reportType == 'Briefly-Officer'">
    
    <div class="container" id="print-section">
        <table class="table table-bordered">
            <thead>
                <tr>
                    <th colspan="1">Vivek Saptahik</th>
                    <th colspan="3">Advt. Payment Receipt Ledger</th>
                    <th colspan="1">Briefly-Officer</th>
                    <th colspan="2">From {{startDate | date: 'dd-MM-yyyy'}} To {{endDate | date: 'dd-MM-yyyy'}}</th>
                </tr>
                <tr>
                    <th>Receipt No</th>
                    <th>Receipt<br> Date</th>
                    <th>Entry <br>Date</th>
                    <th>Advertiser Name</th>
                    <th>Representative <br> Name</th>
                    <th>Office <br> Rep Name</th>
                    <th>Received <br>Amount</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let data of advtOfficierbrieflyFormBeans; let i = index">
                    <tr>
                        <td colspan="2" style="font-weight: bold; font-size: 15px;">Office Representative</td>
                        <td colspan="2" style="font-weight: bold; font-size: 15px;">{{data.off_rep_name}}</td>
                        <td colspan="3"></td>
                    </tr>
                    
                    <!-- Rep-wise grouping -->
                    <ng-container *ngFor="let repGroup of data.rep_groups; let j = index">
                        <tr style="background-color: #f9f9f9;">
                            <td colspan="4" style="font-weight: bold; padding-left: 20px;">Representative: {{repGroup.rep_name}}</td>
                            <td colspan="3"></td>
                        </tr>
                        
                        <!-- Individual records for this rep -->
                        <tr *ngFor="let data2 of repGroup.records; let k = index">
                            <td>{{data2.rcpt_no}}</td>
                            <td>{{data2.rcpt_date}}</td>
                            <td>{{data2.entry_date}}</td>
                            <td>{{data2.advt_name | slice : 0:35}}</td>
                            <td>{{data2.rep_name}}</td>
                            <td style="font-weight: bold;">{{data2.off_rep_name}}</td>
                            <td style="text-align: end;">{{data2.rcv_amt}}</td>
                        </tr>
                        
                        <!-- Rep Total -->
                        <tr style="background-color: #f0f0f0;">
                            <td colspan="6" style="font-weight: bold; padding-left: 40px;">Representative Total</td>
                            <td style="text-align: end; font-weight: bold;">{{repGroup.rep_total}}</td>
                        </tr>
                    </ng-container>
                    
                    <!-- Office Rep Total -->
                    <tr>
                        <td colspan="6" style="font-weight: bold; font-size: 16px;">Office Representative Total</td>
                        <td style="text-align: end; font-weight: bold; font-size: 16px;">{{data.total_amt}}</td>
                    </tr>
                </ng-container>
            </tbody>
            
            <tr>
                <td colspan="4" style="font-weight: bold; font-size: 16px;background-color: #f1f1f1 !important;">Grand Total:</td>
                <td colspan="3" style="font-weight: bold; font-size: 16px; text-align: end;background-color: #f1f1f1 !important;">{{(advtOfficierbrieflyTotal * 1).toFixed(2) }}</td>
            </tr>
        </table>
    </div>
    <div style="margin-left: 80%; margin-bottom: 2%;">
        <button class="noPrint" style="margin-top: 2%; margin-left: 2%"
            (click)="exportExcel('Contract_InDetails_Report')" mat-raised-button color="primary">
            Export
        </button>

        <button class="noPrint" style="margin-top: 2%;" id="print-button" mat-raised-button color="primary" printSectionId="print-section"
          [useExistingCss]="true" ngxPrint style="display: none;">Print</button>
  
        <button class="noPrint" style="margin-top: 2%;" mat-raised-button color="primary" printSectionId="print-section" [useExistingCss]="true" ngxPrint>
          Print
        </button>
        
        <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
            Close
        </button>
    </div>
</div>